import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

import { FETCH_STATUS } from '../constants'

export const NAME = 'incidents'

const DEFAULT_LAT_LNG = {
  X: -78.853771,
  Y: 33.648993,
}

const fetchStatus = (state = FETCH_STATUS.NOT_YET_FETCHED, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return FETCH_STATUS.FETCHING
    case ActionTypes.FETCH_FAILURE:
      return FETCH_STATUS.FETCH_FAILED
    case ActionTypes.FETCH_SUCCESS:
      return FETCH_STATUS.LOADED
    default:
      return state
  }
}

const getIncidentId = (incident) => incident.incidentNumber

const byId = (state = {}, action) => {
  //console.log('action', action) // THIS IS SO WE CAN SEE EVERY ACTION in console during development
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.incidents.forEach((incident) => {
        const i = {
          ...incident,
          longitude:
            (incident.longitude !== 'NaN' && incident.longitude) ||
            DEFAULT_LAT_LNG.X,
          latitude:
            (incident.latitude !== 'NaN' && incident.latitude) ||
            DEFAULT_LAT_LNG.Y,
        }
        byId[getIncidentId(incident)] = i
      })
      return byId
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return action.incidents.map(getIncidentId)
    default:
      return state
  }
}

const initialSelected = { incidentIds: [], current: 0 }
const selected = (state = initialSelected, action) => {
  const { incidentIds, current } = state
  switch (action.type) {
    case ActionTypes.SELECT_INCIDENTS:
      return {
        incidentIds: action.incidentIds,
        current: 0,
      }
    case ActionTypes.NEXT_INCIDENT:
      return {
        ...state,
        current: current + (current < incidentIds.length - 1 ? 1 : 0),
      }
    case ActionTypes.PREV_INCIDENT:
      return {
        ...state,
        current: current - (current > 0 ? 1 : 0),
      }
    case ActionTypes.CLEAR_SELECTION:
      return initialSelected
    default:
      return state
  }
}

const reducer = combineReducers({
  byId,
  allKeys,
  selected,
  fetchStatus,
})

export default reducer
